import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_SALE_TAX, propTypes } from '../../util/types';
import { vatFromTransaction, rateLabel } from '../../util/vat';

import css from './BookingBreakdown.css';

const { Money } = sdkTypes;

// Validate the assumption that the commission exists and the amount
// is zero or negative.
const isValidSaleTax = saleTaxLineItem => {
  return saleTaxLineItem.lineTotal instanceof Money && saleTaxLineItem.lineTotal.amount >= 0;
};

const LineItemSaleTaxMaybe = props => {
  const { transaction, userRole, intl } = props;
  const saleTaxLineItem = transaction.attributes.lineItems.find(
    item => item.code === LINE_ITEM_SALE_TAX && !item.reversal
  );
  if (!saleTaxLineItem) return null;
  // On the invoice and light paths the customer's VAT line is not the provider's.
  if (userRole && saleTaxLineItem.includeFor && !saleTaxLineItem.includeFor.includes(userRole)) {
    return null;
  }
  if (!isValidSaleTax(saleTaxLineItem)) {
    // eslint-disable-next-line no-console
    console.error('invalid sale tax line item:', saleTaxLineItem);
    throw new Error('Sale tax should be present and the value should be zero or positive');
  }
  const { customer } = vatFromTransaction(transaction);
  const rate = Number(saleTaxLineItem.percentage) / 100;
  const label = rateLabel({ rate, label: (customer && customer.label) || 'VAT' }, intl.locale);
  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="BookingBreakdown.vatLine" values={{ rateLabel: label }} />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, saleTaxLineItem.lineTotal)}</span>
    </div>
  );
};

LineItemSaleTaxMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  userRole: string,
  intl: intlShape.isRequired,
};

export default LineItemSaleTaxMaybe;
